export const name = 'serviceRegistrar' as const

/**
 * Resolves (lazily) to a getter for the site `ServicesManager`.
 * Used to defer building the manager out of the renderer-props critical path —
 * see `SiteServicesManagerProvider` in `./siteServiceManager`.
 */
export const SiteServicesManagerProviderSymbol = Symbol('SiteServicesManagerProvider')
